export default "__VITE_ASSET__BPOQ$mIn__"